import { AnimatePresence, motion } from 'framer-motion'
import { Image as ImageComponent } from '@lounge-fe/ui-kit'
import { MediaData } from './types'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { Video } from './Video'
import { useFittingRoomStore } from '../store'

const IMAGE_WIDTH = 960
const IMAGE_QUALITY = 90

export const Media: ShopifySectionComponent<MediaData> = ({ data }) => {
  const media = data?.media ?? []
  const { activeStep } = useFittingRoomStore(({ activeStep }) => ({
    activeStep,
  }))
  const activeMedia = media[activeStep]
  const previousMedia = media[activeStep - 1]

  if (!activeMedia) {
    return <></>
  }

  return (
    <div className="h-[400px] sm:h-[600px] md:h-screen relative">
      <AnimatePresence mode="popLayout">
        <motion.div
          key={
            activeMedia.type === 'media_image'
              ? activeMedia.settings.image
              : activeMedia.settings.video.id
          }
          className="w-full h-full"
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {activeMedia.type === 'media_image' ? (
            <ImageComponent
              loading="eager"
              data={{
                src: activeMedia.settings.image,
                quality: IMAGE_QUALITY,
                width: IMAGE_WIDTH,
              }}
              className="w-full h-full object-cover object-center"
            />
          ) : (
            <Video currentMedia={activeMedia} previousMedia={previousMedia} />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
